import { useMemo } from 'react'
import useAppUIStateHandlers from '@/app_ui/hooks/useAppUIStateHandlers'

export const useLuruToast = () => {
  const { showToast, hideToast } = useAppUIStateHandlers()
  return useMemo(() => ({ showToast, hideToast }), [showToast, hideToast])
}
